
export const sigmaToPercentile = (sigma: number): number => {
  const erf = (x: number): number => {
    const a1 =  0.254829592;
    const a2 = -0.284496736;
    const a3 =  1.421413741;
    const a4 = -1.453152027;
    const a5 =  1.061405429;
    const p  =  0.3275911;
    
    const sign = x >= 0 ? 1 : -1;
    x = Math.abs(x);
    
    const t = 1.0 / (1.0 + p * x);
    const y = 1.0 - (((((a5 * t + a4) * t) + a3) * t + a2) * t + a1) * t * Math.exp(-x * x);
    
    return sign * y;
  };
  
  const percentile = 50 * (1 + erf(sigma / Math.sqrt(2)));
  return Math.round(percentile);
};

export const getCategoryLabel = (percentile: number): string => {
  if (percentile >= 80) return 'Very High';
  if (percentile >= 60) return 'High';
  if (percentile >= 40) return 'Moderate';
  if (percentile >= 20) return 'Low';
  return 'Very Low';
};
